export const setCostDelivery = data => ({
    type: 'SET_COST_DELIVERY',
    data,
  });

export const clearCostDelivery = () => ({
    type: 'CLEAR_COST_DELIVERY'
  });